import "core-js/modules/es.array.iterator.js";
import { useAuthContext } from '@isyc-react/auth/modules/context';
import { Spinner } from '@isyc-react/design/bootstrap';
import React from 'react';
import { NewoSessionContext } from "./newo.context";
import { useNewoContextReadLazyQuery } from "../common/api/graphql/queries";
export const NewoProvider = props => {
  const {
    children
  } = props;
  const {
    user
  } = useAuthContext();
  const [query, {
    data,
    loading,
    error
  }] = useNewoContextReadLazyQuery();
  React.useEffect(() => {
    if (user) {
      query({
        variables: {
          user_id: user.id
        }
      });
    }
  }, [user]);
  if (loading || !data) {
    return /*#__PURE__*/React.createElement(Spinner, null);
  }
  if (error) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "ERROR");
  }
  const canAccessSite = id => {
    const sitePermissionList = data.coreElearningContext.sitePermissionList;
    const sitePermission = sitePermissionList.find(x => x.id === id);
    if (sitePermission) {
      return sitePermission.hasAccess;
    }
    return data.coreElearningContext.canAccessSitesByDefault;
  };
  return /*#__PURE__*/React.createElement(NewoSessionContext.Provider, {
    value: {
      hasAcademicRecords: data.coreElearningContext.hasAcademicRecords,
      canAccessSitesByDefault: data.coreElearningContext.canAccessSitesByDefault,
      sitePermissionList: data.coreElearningContext.sitePermissionList,
      canAccessSite: canAccessSite,
      studentExternalId: data.coreElearningContext.studentExternalId,
      idStudent: data.coreElearningContext.idStudent
    }
  }, children);
};